<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">{{collection | capitalise | pluralise}}</b-link> / {{item ? item.name : ''}}</span>
        <b-button size="sm" class="float-right" :to="{name: `${collection}_edit`}" v-if="profile.role === 'admin'">Edit</b-button>
        <b-button size="sm" :to="{name: `${collection}_train`}" v-if="item && item.status === 'training'" class="mr-2 float-right">Train</b-button>
        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fvoice~2F${$route.params.id}`" target="_blank"><i class="fas fa-database"></i></b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <b-alert variant="info" :show="item.status == constants.voice_status.pending">
          This voice is <strong>pending</strong> to be queued. This could take up to 6 hours to complete.
          <LoadingBar v-if='item.descript_trial_started' :seconds="12 * 60 * 60" :start_date="item.descript_trial_started" class='mt-2'/>
        </b-alert>
        <b-alert variant="info" :show="item.status == constants.voice_status.processing">
          This voice is <strong>processing</strong>, this can take up to 24 hours to complete.
          <LoadingBar v-if='item.descript_trial_started' :seconds="12 * 60 * 60" :start_date="item.descript_trial_started" class='mt-2'/>
        </b-alert>
        <b-alert variant="warning" :show="item.status == constants.voice_status.error"><strong>An error occured:</strong> {{item.error_message}}</b-alert>

        <div v-if="item.status === constants.voice_status.complete" class="mb-2">
          <!-- <h4>Try it out</h4> -->

          <b-input-group >
            <b-form-input v-model="text" placeholder="Enter text" :maxlength="profile.role === 'admin' ? null : 30"></b-form-input>
            <b-input-group-append>
              <LoadingButton :loading="audio_loading" @click="text_to_speech" variant='primary'>Generate</LoadingButton>
            </b-input-group-append>
          </b-input-group>

          <Audio v-if="audio_url" :source="audio_url" :autoplay="true" />

          <!-- <audio  :src="audio_url" controls autoplay></audio> -->
        </div>

        <div v-if="!is_training && item.status === 'training'" class='mb-2'>
          <h4>Train the voice</h4>
          <p>Record a minimum of 10 minutes of audio to train your voice. Read in a high energy voice. Use a good quality microphone if you have one.</p>
          <b-button :to="{name: `${collection}_train`}">Start Training</b-button>
        </div>


        <!-- <br /> -->
        <!-- <b-button :href="item.training_audio_url" target="_blank" class="mb-2">View training audio</b-button> -->


        <!-- TODO -->
        <!-- <h4>Identity</h4>
        <p>To avoid abuse you must verify your legal identity</p>
        <div v-if="profile.verified_identity === false" class='mb-2'>
          <b-button @click='verify_identity'>Verify identity</b-button>
        </div>
        <div v-if="profile.verified_identity === true" class='mb-2'>
          <p>Your identity has been verified</p>
        </div>
        <div v-if="profile.verified_identity === 'pending'" class='mb-2'>
          <p>Your identity verification in currently in progress, please check back later</p>
        </div> -->
      </div>
    </b-card>

    <!-- <h4>Clone Samples</h4>
    <LoadingButton @click="generate_samples" :loading="generating_samples" v-if="profile.role === 'admin'" variant='warning'>Generate Samples</LoadingButton>
    <b-card class='mt-2' no-body>
      <b-table show-empty :items="samples" :fields="['text', 'audio']">
        <template v-slot:cell(audio)='data'>
          <Audio :source="data.item.url" size="sm" />
        </template>
      </b-table>
    </b-card> -->
  </b-container>
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db, storage } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import api from '@/lib/api.js'
import Audio from '@/components/Audio.vue'

export default {
  metaInfo: {title: 'Clone'},
  mixins: [ItemMixin],
  components: {Audio},
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id),
      // samples: db.collection(this.collection).doc(this.$route.params.id).collection('sample').orderBy('created')
    }
  },
  data() {
    return {
      samples: [],
      generating_samples: false,
      audio_loading: false,
      text: null,
      audio_url: null,
      collection: 'voice',
      is_training: false, // TODO
    }
  },
  methods: {
    async generate_samples() {
      this.generating_samples = true

      let proms = []
      let words = ['Mary', 'Robert', 'Patricia', 'James', 'Jennifer', 'Michael', 'Linda', 'William', 'Elizabeth', 'David', 'Barbara', 'Richard', 'Susan', 'Joseph', 'Jessica', 'Thomas', 'Sarah', 'Charles', 'Karen', 'Christopher', 'Nancy', 'Daniel', 'Lisa', 'Matthew', 'Margaret', 'Anthony', 'Betty', 'Donald', 'Sandra', 'Mark', 'Ashley', 'Paul', 'Dorothy', 'Apple', 'Amazon', 'Microsoft', 'Walt Disney', 'Berkshire Hathaway', 'Starbucks', 'Alphabet', 'Google', 'JPMorgan Chase', 'Costco Wholesale', 'Salesforce', 'Netflix']
      for (let word of words) {
        proms.push(this.generate_sample(word, this.item.id))
      }

      await Promise.all(proms)

      this.generating_samples = false
    },
    async generate_sample(text) {
      let result = await api.text_to_speech(text, this.item.id)

      let data = await fetch(result.data.url)
      let blob = await data.blob()

      let snap = await storage.ref().child(`${this.profile.id}/voice/${this.$route.params.id}/samples/${db.collection('media').doc().id}`).put(blob)
      let url = await snap.ref.getDownloadURL()

      let sample = {
        created: new Date(),
        updated: new Date(),
        text: text,
        url: url
      }

      await db.collection(this.collection).doc(this.$route.params.id).collection('sample').add(sample)
    },
    start_training() {
      this.is_training = true
      this.current_script = null
      let i = 0
      for (let script of this.item.script) {
        if (script.url === null) {
          this.current_script = i
        }
        i++
      }
    },
    async text_to_speech() {
      this.audio_url = null

      // TODO
      // if (this.text.length > 60 || !this.text) {
      //   this.$swal({title: 'Enter one word', text: "Please enter between 0 and 60 characters", icon: 'warning'})
      //   return
      // }

      this.audio_loading = true
      let response
      try {
        response = await api.text_to_speech(this.text, this.item.id)
      } catch (err) {
        this.audio_loading = false
        console.warn(err)
        this.$swal({title: 'Uh oh', text: 'Something went wrong generating audio, please contact support', icon: 'warning'})
        return
      }
      this.audio_loading = false

      console.log(response.data)

      if (response.data.error) {
        this.$swal({title: response.data.error, text: response.data.message, icon: 'warning'})
        return
      }

      this.audio_loading = false
      this.audio_url = response.data.url

      return response.data.url
    },
    async verify_identity() {
      let response = await api.request_identity_verification()
      window.open(response.data.redirect_to_url, '_blank')
    },
  }
}
</script>

<style>

</style>
